export default {"src":"/_next/static/image/public/images/flags/flag_43.884e24ea4cd57bb74abad88cdc9d3759.svg","height":16,"width":25};